import { h } from 'preact';
import './Widget.css';

const iconList = [
  { icon: 'https://cdn.trybeans.com/lib/arrow/3.1/img/widget/snow.svg', preset: 'snow' },
  { icon: 'https://cdn.trybeans.com/lib/arrow/3.1/img/widget/love.svg', preset: 'love' },
  { icon: 'https://cdn.trybeans.com/lib/arrow/3.1/img/widget/help.svg', preset: 'help' },
  { icon: 'https://cdn.trybeans.com/lib/arrow/3.1/img/widget/gift.svg', preset: 'gift' },
  { icon: 'https://cdn.trybeans.com/lib/arrow/3.1/img/widget/light.svg', preset: 'light' },
];

export default function Widget({ display, small, onClick }) {
  return (
    <div id="beans-snow-widget-component-widget-wrapper">
      {small ? (
        <div
          id="beans-snow-widget-component-attention-overlay"
          style={{ backgroundColor: display.color || '#0278D1', zIndex: 2147483647 - 3 }}
        />
      ) : null}
      <div
        id="beans-snow-widget-component-widget"
        onClick={onClick}
        style={{ backgroundColor: display.color || '#0278D1', zIndex: 2147483647 - 2 }}
        className={small ? 'small' : ''}
      >
        <div className="beans-snow-widget-component-icon-wrapper">
          {iconList.map((icon) =>
            display.icon_preset === icon.preset ? (
              <img style="width: 36px;" key={icon.preset} src={icon.icon} alt="Widget logo" />
            ) : null
          )}
        </div>
      </div>
    </div>
  );
}
